export enum InmarIssueCode {
  NOT_HEADED_TO_INMAR = "not-headed-to-inmar",
  MISSING_IDS = "missing-ids",
  PENDING_MANUAL_REVIEW = "pending-manual-review",
  NO_SHIPMENTS_PRESENT = "no-shipments-present",
  INTERNAL_ERROR = "internal-error",
  SUCCESS = "success",
}

export const inmarIssueCodeToDisplayText: Record<InmarIssueCode, string> = {
  [InmarIssueCode.NOT_HEADED_TO_INMAR]: "not headed to Inmar",
  [InmarIssueCode.MISSING_IDS]: "missing IDs",
  [InmarIssueCode.PENDING_MANUAL_REVIEW]: "pending manual review",
  [InmarIssueCode.NO_SHIPMENTS_PRESENT]: "no shipments present",
  [InmarIssueCode.INTERNAL_ERROR]: "internal error",
  [InmarIssueCode.SUCCESS]: "success",
};

export const INMAR_DATADOG_METRIC = "redo.return.inmar.createRma";

export enum InmarMetricTags {
  OUTCOME = "redo.return.inmar.outcome",
  NUM_ITEMS_ADDED = "redo.return.inmar.numItemsAdded",
}
